import { createFileRoute } from '@tanstack/react-router';

import { ComponentsImporterPage } from '@/areas/components/ComponentsImporter/ComponentsImporterPage';
import { canOpenPartLibraryImporters } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/components/importer')({
    staticData: { access: { permissions: canOpenPartLibraryImporters }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ComponentsImporterPage />;
}
